module.exports = __webpack_public_path__ + "img/swiper3.fc2111f6.png";